"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../hooks");
var _net = require("../../../models/graphql-types/net");
var _utils = require("../../../utils");
var _SubCategory = require("./SubCategory");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const DesktopSubLinksGenerator = ({
  subCategories
}) => {
  const isMobile = (0, _hooks.useIsMobile)();
  const [activeSubCategory, setActiveSubCategory] = (0, _react.useState)('');
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const analyticsData = (0, _react.useCallback)(url => () => {
    (0, _utils.logUserClick)(url);
  }, []);

  // istanbul ignore next -- not reachable as it is used only on mobile
  const handleSubCategoryClick = (0, _react.useCallback)(subCategory => {
    if (isMobile && subCategory === activeSubCategory) {
      setActiveSubCategory('');
    } else {
      setActiveSubCategory(subCategory);
    }
  }, [activeSubCategory, isMobile]);
  if (!subCategories) {
    return null;
  }

  /** As workaround to display correctly on all browser it looks better when categories are sorted by number of sub categories */
  const sortedSubCategories = subCategories.sort((a, b) => b.children.length - a.children.length);
  /** What's new and All category links which are randomly ordered and have to be first on the list */
  const firstTwoItems = (0, _utils2.getWhatsNewAndAllCategory)(subCategories);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopSubLinksNewAndAllRoot, {
      children: firstTwoItems.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopSubLinksSubcategory, {
        "data-testid": getTestId(_constants.DESKTOP_SUBLINKS_SUBCATEGORY),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DesktopSubLinksNewAndAll, {
          href: item.url ?? undefined,
          "data-testid": getTestId(_constants.DESKTOP_SUBLINKS_NEW),
          onClick: analyticsData(item.url),
          children: [item.title, /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
        })
      }, item.url))
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DesktopSubLinksRoot, {
      "data-testid": getTestId(_constants.DESKTOP_SUBLINKS_ROOT),
      children: [sortedSubCategories.map(subCategory => {
        if (Boolean(subCategory) && (0, _utils2.isSubCategoryOrLookBookLink)(subCategory.linkType)) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubCategory.SubCategory, {
            subCategory: subCategory,
            activeSubCategory: activeSubCategory,
            handleSubCategoryClick: handleSubCategoryClick
          }, subCategory.url);
        }
        return null;
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopSubLinksOtherLinks, {
        "data-testid": getTestId(_constants.DESKTOP_SUBLINKS_OTHER_LINKS),
        children: subCategories.map(subCategory => {
          if (
          // TODO -- Boolean(subCategory) - Temporary solution to filter out null values which is not included in type
          Boolean(subCategory) && subCategory.linkType === _net.NavigationLinkType.PopularBrands) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubCategory.SubCategory, {
              isBrands: true,
              subCategory: subCategory,
              handleSubCategoryClick: handleSubCategoryClick,
              "data-testid": getTestId(_constants.POPULAR_BRANDS)
            }, subCategory.url);
          }
          // TODO -- Boolean(subCategory) - Temporary solution to filter out null values which is not included in type
          if (Boolean(subCategory) && (0, _utils2.isNotCategoryLink)(subCategory.linkType) && subCategory.url) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopSubLinksSegment, {
              href: subCategory.url,
              "data-testid": getTestId(_constants.DESKTOP_SUBLINKS_SEGMENT),
              children: subCategory.title
            }, subCategory.url);
          }
          return null;
        })
      })]
    })]
  });
};
var _default = exports.default = DesktopSubLinksGenerator;
